export const REGISTER_BY_GOOGLE = "/auth/register/google";
export const LOGIN_BY_GOOGLE = "/auth/login/google";

export const REGISTER_BY_EMAIL = "/auth/register/email";
export const LOGIN_BY_EMAIL = "/auth/login/email";

export const VERIFY_EMAIL = "/auth/verify/email";
export const RESEND_VERIFICATION = "/auth/verify/resend";

export const FOGOT_PASSWORD_SEND_VERIFICATION =
  "/auth/forgot-password/send-verification";
export const RESET_PASSWORD = "/auth/forgot-password/reset";

export const FETCH_USER_BY_ID = "/user/get/";

export const FETCH_ALL_TXS = "/tx/all";

export const FETCH_STRIPE_CLIENT_SECRET = "/stripe/create-client-secret";

export const TRANSFER_CHRLE_IN_STRIPE = "/web3/stripe/transfer";
export const FETCH_WITHDRAW_ESTIMATE_GAS_FEE_IN_STRIPE =
  "/web3/withdraw/estimate-gas-fee";
export const WITHDRAW_CHRLE = "/web3/withdraw/chrle";

export const REQUEST_RELEASE_TX = "/support/request/release-tx";
